import React from 'react';
import WmwSection8b from '../../../../../components/course/churchschool/wmw/WmwSection8b';
import JepsplSection from '../../../../../components/course/churchschool/JepsplSection';
import WarningSection from '../../../../../components/course/churchschool/WarningSection';
import WmwSection14 from '../../../../../components/course/churchschool/wmw/WmwSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../../components/course/churchschool/event/GodDealWeekSectionOct';

const BoostupJSBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}
      <WmwSection8b />
      <WarningSection />
      <JepsplSection />
      <WmwSection14 />
    </>
  );
};

export default BoostupJSBookMain;
